<template>
    <div class="morph">
        <div class="basket_loading" v-if="userStore.order.is_loading">
            <loading></loading>
        </div>
        <div v-if="userStore.order.success" class="order_result">
            <div class="grey_border">
                <div class="title important_blue">Заказ оформлен</div>
                <div class="case" v-html="userStore.order.message"></div>
                <div class="case">Вы будете перенаправлены на страницу заказов через 10 сек.</div>
            </div>
        </div>
        <div v-if="userStore.user.web_basket.count === 0" class="basket_empty">
            <div class="grey_border">
                <div class="title important_blue">Корзина пуста</div>
                <div class="case">Для оформления заказа, добавьте в корзину товары, воспользовавшись <span @click="route_to('Search')" class="psevdo_link">Поиском</span></div>
            </div>
        </div>
        <div class="basket_wrap" v-if="userStore.user.web_basket.count !== 0 && !userStore.user.web_basket.is_loading && !userStore.order.is_loading">
            <div class="wrapper">
                <div class="Rtable Rtable--5cols Rtable--collapse">
                    <div class="Rtable-row Rtable-row--head">
                        <div class="Rtable-cell title-cell column-heading">Наименование</div>
                        <div class="Rtable-cell price-cell column-heading">Склад</div>
                        <div class="Rtable-cell price-cell column-heading">Цена</div>
                        <div class="Rtable-cell countui-cell column-heading">Кол-во</div>
                        <div class="Rtable-cell summa-cell column-heading">Сумма</div>
                        <div class="Rtable-cell actions-cell column-heading">Операции</div>
                    </div>
                    <div class="row Rtable-row" v-for="(item, index) in userStore.user.web_basket.items" :key="index">
                        <div class="Rtable-cell title-cell">
                            <div class="Rtable-cell--heading">Наименование</div>
                            <div class="Rtable-cell--content title-content">{{ item.name }}</div>
                        </div>
                        <div class="Rtable-cell price-cell">
                            <div class="Rtable-cell--heading">Склад</div>
                            <div class="Rtable-cell--content title-content">{{ item.storehouse }}</div>
                        </div>
                        <div class="Rtable-cell price-cell">
                            <div class="Rtable-cell--heading">Цена</div>
                            <div class="Rtable-cell--content price-content">{{ item.price }}</div>
                        </div>
                        <div class="Rtable-cell countui-cell">
                            <div class="Rtable-cell--heading">Кол-во</div>
                            <div class="Rtable-cell--content countui-content">


                                <addBasket
                                    :in_basket="item.count"
                                    :max="item.stock"
                                    :at_load="item.lock"
                                    :is_update="item.is_update"
                                    :item="item"
                                    v-on:changeBasket="changeBasket"
                                >

                                </addBasket>
                            </div>
                        </div>
                        <div class="Rtable-cell summa-cell">
                            <div class="Rtable-cell--heading">Сумма</div>
                            <div class="Rtable-cell--content summa-content">{{ item.sum }}</div>
                        </div>
                        <div class="Rtable-cell actions-cell">
                            <div class="Rtable-cell--heading">Операции</div>
                            <div class="Rtable-cell--content actions-content">
                                <div class="actions_wrap">
                                    <div class="ico del" v-if="!item.lock" @click="changeBasket(item,0)" title="Удалить из корзины">
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
                                            <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="b_total">
                Итого: <span>{{ userStore.user.web_basket.summa }}</span> ₽
            </div>
            <div class="buttons_wrap">

            </div>
        </div>
        <div v-if="!userStore.order.success && userStore.user.web_basket.count !== 0 && !userStore.order.is_loading" class="order_wrap blue_border">
            <div class="title">Оформление заказа</div>
            <div class="form_row">
                <div class="s_wrap">
                    <div class="select_wrap">
                        <v-select
                            :options="userStore.order.adreses"
                            v-model="userStore.order.fields.address"
                        ></v-select>
                        <div class="select_label">Адрес доставки</div>
                    </div>
                </div>
                <div class="input_wrap">
                    <input v-model="userStore.order.fields.date" id="input_date" type="date" class="input_gray">
                    <label for="input_date" class="input_label">Желательная дата отгрузки</label>
                </div>
                <div class="s_wrap">
                    <div class="select_wrap">
                        <v-select
                            :options="userStore.order.contacts"
                            v-model="userStore.order.fields.contact"
                        ></v-select>
                        <div class="select_label">Контактное лицо</div>
                    </div>
                </div>
                <div class="input_wrap">
                    <input v-model="userStore.order.fields.phone" id="input_phone" type="tel" pattern="[0-9]-[0-9]{3}-[0-9]{3}-[0-9]{2}-[0-9]{2}" class="input_gray">
                    <label for="input_phone" class="input_label">Телефон</label>
                </div>
                <div class="s_wrap">
                    <div class="select_wrap">
                        <v-select
                            :options="[{label: 'Безналичный расчет', option: '1'},{label: 'Наличный расчет от юр. лица', option: '2'},{label: 'Наличный расчет', option: '3'},{label: 'Оплата картой', option: '4'}]"
                            :reduce="label => label.option"
                            v-model="userStore.order.fields.paid"
                        ></v-select>
                        <div class="select_label">Форма оплаты</div>
                    </div>
                </div>
                <div class="text_wrap">
                    <label for="input_comment" class="input_label">Комментарий</label>
                    <textarea class="textarea_gray" name="comment" v-model="userStore.order.fields.comment" id="input_comment"></textarea>
                </div>
                <div class="send_wrap">
                    <div v-if="!userStore.order.is_loading" class="button_simple b_blue" @click="try_order">Оформить заказ</div>
                </div>

            </div>
            <div v-if="userStore.order.error" class="order_result">
                <div class="grey_border">
                    <div class="title important_red">Ошибка</div>
                    <div class="case">{{ userStore.order.message }}</div>
                </div>
                <div class="grey_border" v-for="(notice, index) in userStore.order.notices" :key="index">
                    <div class="title important_blue" v-if="notice.type ==='input_error'">Ошибка в поле</div>
                    <div class="title important_blue" v-else>Ошибка</div>
                    <div class="case">{{ notice.message }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {useUserStore} from "@/stores/UserStore";
import loading from "@/components/support/loading";
//import changeCount from "@/components/support/changeCount";
import addBasket from "@/components/support/addBasket";
import moment from "moment/moment";

import Search from "@/views/Search";
import axios from "axios";


export default {
    name: "Basket",
    components: {
        loading,
//        changeCount,
        addBasket,
        Search
    },
    setup() {
        const userStore = useUserStore()
        return {
            userStore
        }
    },
    data: function () {
        return {
            page: {
                title: 'Корзина',
                show_menu: false,
            }
        }
    },
    props: ['config'],
    methods: {


        route_to(name) {
            this.$router.push({name: name})
        },


        changeBasket(basket_item, basket_count) {


            const userStore = useUserStore();

            if (basket_count <= 0) {
                basket_count = 0;
            }

            let web_basket_item = userStore.user.web_basket.items.find(item => item.id === basket_item.id && item.storehouse === basket_item.storehouse);
            web_basket_item.count = basket_count;


            const params = new URLSearchParams();
            params.append('type', 'cart_update');

            for (const web_basket_index in userStore.user.web_basket.items) {
                params.append('data[' + web_basket_index + '][id]', userStore.user.web_basket.items[web_basket_index].id);
                params.append('data[' + web_basket_index + '][uuid]', userStore.user.web_basket.items[web_basket_index].uuid);
                params.append('data[' + web_basket_index + '][id_price]', userStore.user.web_basket.items[web_basket_index].id_price);
                params.append('data[' + web_basket_index + '][id_storehouse]', userStore.user.web_basket.items[web_basket_index].id_storehouse);
                params.append('data[' + web_basket_index + '][storehouse]', userStore.user.web_basket.items[web_basket_index].storehouse);
                params.append('data[' + web_basket_index + '][in_stock]', userStore.user.web_basket.items[web_basket_index].in_stock);
                params.append('data[' + web_basket_index + '][stock]', userStore.user.web_basket.items[web_basket_index].stock);
                params.append('data[' + web_basket_index + '][count]', userStore.user.web_basket.items[web_basket_index].count);
            }


            if (basket_count == 0) {
                let web_basket_item_index = userStore.user.web_basket.items.findIndex(item => item.id === basket_item.id && item.storehouse === basket_item.storehouse);
                userStore.user.web_basket.items.splice(web_basket_item_index, 1)
            }

            let api_url = '/api/basket_add';
            this.$http.post(api_url, params)
                .then((response) => {


                    var data = response.data;

                    userStore.calc_web_basket();

                    if (typeof (data.success) !== "undefined" && (data.success === true)) {
                        this.$notifySuccess(data.message);

                    }
                    if (typeof (data.error) !== "undefined" && (data.error === true)) {
                        this.$notifyError(data.message);
                    }


                })
                .catch((error) => {
                    console.log(error);
                });


        },


        clear_web_basket() {

            this.$notifyInfo('Очищаем корзину');
            this.userStore.user.web_basket.is_loading = true
            this.$http.get('/api/basket_clear', {})
                .then((response) => {
                    let data = response.data;

                    this.userStore.user.web_basket.is_loading = false;

                    if (typeof (data.success) !== "undefined" && (data.success === true)) {
                        this.$notifySuccess(data.message);
                        this.userStore.fill();

                    }
                    if (typeof (data.error) !== "undefined" && (data.error === true)) {
                        this.$notifyError(data.message);
                    }

                })
                .catch((error) => {
                    console.log(error);
                });

        },


        try_order() {
            this.$notifyInfo('Отправляем данные заказа');
            this.userStore.try_order().then(this.response_process);
        },


    },

    mounted() {
        this.userStore.order.fields.address = this.userStore.order.adreses[0];
        this.userStore.order.fields.date = moment().format('YYYY-MM-DD');
        this.userStore.order.fields.contact = this.userStore.order.contacts[0];
        this.userStore.order.fields.paid = '1';

    },

    created() {
        this.userStore.order.success = false;
        this.$emit('setPagesVars', this.page);
    },
}
</script>

<style scoped>
.buttons_wrap {
    display: flex;
    flex-direction: row;
    margin: 30px 0 50px 0;
}

.buttons_wrap .button_simple {
    margin: 0 10px 0 10px;
}

.basket_empty {
    margin: 50px 0 50px 0;
}

.order_wrap {
    margin: 50px 0 50px 0;
}

.input_wrap, .text_wrap, .s_wrap, .send_wrap {
    width: 100%;
}

.input_gray, .textarea_gray {
    width: 100%;
}

.s_wrap, .input_wrap, .text_wrap, .send_wrap {
    margin-bottom: 20px;
    margin-right: 0px;
}

.order_result {
    margin: 50px 0 50px 0;
}

.order_result .grey_border {
    margin: 25px 0 0 0;
}

.count_ui .row {
    border-bottom: 1px dashed #dee2e6;
    margin: 5px 0 5px 0;
    padding: 5px 0 5px 0;
}

.add_ui {
    width: 133px;
    height: 38px;
    border: solid 1px #ADADAD;
    display: flex;
    flex-direction: row;
}

.add_ui .added {
    font-size: 24px;
    font-weight: bold;
    color: #174A8B;
    width: 40px;
    line-height: 28px;
    color: #659157;
    margin: 4px 0 0 0;
    text-align: center;
}

.add_ui .button {
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: bold;
    color: #ADADAD;
    text-align: center;
    border: solid 1px #FFF;
    cursor: pointer;
    margin: 5px 2px 0px 2px;
}

.add_ui .active, .add_ui .button:hover {
    border: solid 1px #ADADAD;
    color: #174A8B;
}

/* RTABLE start
==================================== */
* {
    box-sizing: border-box;
}

.wrapper {
    width: 100%;
    margin-bottom: 30px;
}


/* Table column sizing
================================== */
.title-cell {
    width: 43%;
    padding-left: 2%;
}

.price-cell {
    width: 50px
}

.countui-cell {
    width: 150px;
}

.summa-cell {
    width: 100px;
}

.actions-cell {
    width: 100px;
    text-align: center
}

/* Apply styles
================================== */
.Rtable {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
}

.Rtable .Rtable-row {
    width: 100%;
    display: flex;
    border-bottom: 1px dashed #b7b7b7;
}

.Rtable .checked {
    background-color: #40769E;
}

.Rtable .Rtable-row .Rtable-cell {
    box-sizing: border-box;
    flex-grow: 1;
    overflow: hidden;
    list-style: none;
    line-height: 38px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.Rtable .Rtable-row .Rtable-cell.column-heading {
    background-color: #174A8B;
    color: white;
}

.Rtable .Rtable-row .Rtable-cell .Rtable-cell--heading {
    display: none;
}

.Rtable a {
    color: #174A8B;
    text-decoration: underline;
}

.Rtable a:hover {
    color: #174A8B;
    text-decoration: underline;
}

.Rtable .actions_wrap {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.Rtable .actions_wrap .ico {
    display: block;
    width: 25px;
    height: 25px;
    margin-right: 20px;
    margin-top: 5px;
    cursor: pointer;
}

.Rtable .actions_wrap .ico svg {
    width: 25px;
    height: 25px;
    fill: #174A8B;
}

/* Responsive
==================================== */
@media all and (max-width: 1200px) {
    .Rtable--collapse {
        display: block;
        width: 100%;
        box-shadow: none;
    }

    .Rtable--collapse .Rtable-row {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 20px 0 20px 0;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell {
        width: 100% !important;
        display: flex;
        align-items: center;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell .Rtable-cell--heading {
        display: inline-block;
        flex: 1;
        max-width: 120px;
        min-width: 120px;
        color: #174A8B;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell .Rtable-cell--content {
        flex: 2;
    }

    .Rtable--collapse .title-cell {
        order: -1;
        padding-left: 0 !important;
    }

    .Rtable--collapse .title-cell .Rtable-cell--content {
        padding-left: 0 !important;
    }

    .Rtable--collapse .Rtable-row--head {
        display: none;
    }

    .Rtable--collapse .actions-cell {
        text-align: left;
    }

    .Rtable--collapse .actions-cell .actions_wrap {
        justify-content: left;
    }
}

.no-flexbox .Rtable {
    display: block;
}

.no-flexbox .Rtable.Rtable-cell {
    width: 100%;
}

/* RTABLE END
==================================== */
</style>
